/*eslint-disable */

export const tcColumnDirective = () => {
    'ngInject';

    return {
        restrict: 'E',
        require: '^?tcGrid',
        replace: true,
        transclude: true,
        template(element, attrs) {
            var template = "<div class='tc-display_td' ng-transclude";

            if(attrs.tcIgnoreClick) {
                template += ` ng-click="$event.preventDefault();$event.stopPropagation();"`;
            }

            template += "></div>";

            return template;
        },
        compile: function(element, attrs) {
            if(attrs.tcIgnoreClick) {
                element.attr('ng-click', 'test();vm.test()');
            }

            return {
                post: (scope, element, attrs, ctrl) => {
                    if(ctrl) {
                        ctrl.registerColumn(element, attrs);
                    }
                }
            }
        },
        controller($scope, $element, $attrs) {
            'ngInject';

            $scope.test = function() {
                console.log('test');
            }
        }
    };
};

/*eslint-enable */


// WEBPACK FOOTER //
// ./src/app/components/tcGrid/tcColumn.directive.js